import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3fbdafec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = ["id", "onClick"]
const _hoisted_7 = { class: "guide-box" }
const _hoisted_8 = ["src"]

import { nextTick, onMounted, ref } from 'vue'
import lottie from 'lottie-web'
import lottie_json from '/public/lottie/word_card/data.json'
import { setTimeoutSync } from '@/assets/js/utils'
import { Toast } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardGroup',
  props: {
  data: {
    type: Object,
    default: {}
  },
  Id: {
    type: String,
    default: ''
  }
},
  emits: ['newCardRecord'],
  setup(__props, { emit: __emit }) {

const props = __props

const $emit = __emit

const show = ref(false)
const imgSrc = ref(null)

const addClass = (row, id) => {
  $emit('newCardRecord', props.Id)
  setTimeout(() => {
    // 添加动效
    row.is_new = 0
    const el = document.getElementById(id)
    el.classList.add('card_blur')
  }, 100)
}

const cardDetail = async (e, item, id) => {
  const rect = e.target.getBoundingClientRect()
  const { x, y } = rect
  if (item.is_belong !== 1) {
    return Toast('字卡还未解锁，快去互动绘本解锁吧')
  }

  imgSrc.value = item.img_url

  const el = document.getElementById(id)
  const classList = el.classList
  // 移除动效
  if (classList.contains('card_blur')) {
    classList.remove('card_blur')
  }

  // 点击卡片原地定位
  // classList.add('fixed')
  // el.style.left = x - 10 + 'px'
  // el.style.top = y - 10 + 'px'

  // 添加平移动画
  // await setTimeoutSync()
  // classList.add('translation')

  // 平移动画结束
  // await setTimeoutSync(null, 300)

  // 渲染popup层
  show.value = true
  nextTick(() => renderLottie())

  // 添加卡片详情动效，移除平移class
  await setTimeoutSync()
  document.querySelector('.popup').classList.add('animate_box')
  // classList.remove('fixed')
  // classList.remove('translation')
}

const renderLottie = () => {
  const lottiePath = process.env.NODE_ENV === 'development' ? '/images/' : '/ibook/images/'
  lottie_json?.assets?.forEach((item) => {
    item.u = lottiePath
  })

  lottie.loadAnimation({
    container: document.querySelector('.guide-box'), // 元素动画容器
    renderer: 'svg',
    loop: true,
    animationData: lottie_json // the path to the animation json
  })
}

const closePopup = () => {
  document.querySelector('.popup').classList.remove('animate_box')
  document.querySelector('.popup').classList.add('animate_box_out')
  setTimeout(() => {
    show.value = false
  }, 500)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "《" + _toDisplayString(__props.data.book_lecture_title) + "》", 1)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.data.card_num) + "个生字", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.card, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "wrap_card",
          key: item.unionid
        }, [
          _createElementVNode("div", {
            id: 'card_' + __props.data.book_lecture_id + '_' + index,
            class: _normalizeClass(["card", [
            item.is_belong === 1 ? '' : 'card_back',
            item.is_new === 1 ? addClass(item, 'card_' + __props.data.book_lecture_id + '_' + index) : ''
          ]]),
            onClick: _withModifiers((e) => cardDetail(e, item, 'card_' + __props.data.book_lecture_id + '_' + index), ["stop"])
          }, [
            _withDirectives(_createElementVNode("span", null, _toDisplayString(item.title), 513), [
              [_vShow, item.is_belong === 1]
            ])
          ], 10, _hoisted_6)
        ]))
      }), 128))
    ]),
    (show.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: closePopup,
          class: "popup"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              onClick: _withModifiers(($event: any) => (null), ["stop"]),
              src: imgSrc.value,
              alt: "",
              srcset: ""
            }, null, 8, _hoisted_8)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})